import { useCallback } from "react";
import { toast } from "react-toastify";
import dataService from "../../../../../helpers/dataService";

/**
 * Hook utilitaire pour normaliser les appels API avec gestion d'erreur.
 * Retourne une fonction `apiCall(method, url, data, onSuccess, onError?)`.
 * En cas d'erreur, affiche un toast sauf si onError est fourni.
 */
const useApiCall = () => {
  const apiCall = useCallback(
    (method, url, data, onSuccess, onError) => {
      dataService[method](
        url,
        data,
        (result) => {
          if (onSuccess) onSuccess(result);
        },
        (err) => {
          if (onError) {
            onError(err);
          } else {
            toast.error(
              "Erreur : " +
                (Object.values(err).join(", ") || "Erreur inconnue"),
            );
          }
        },
      );
    },
    [],
  );

  return apiCall;
};

export default useApiCall;
